import { InstitutionAddEditFormFields } from 'types/forms/institution';
import { InstitutionCreateData } from 'types';

export const parseInstitutionAddFormFieldsIntoInstitutionCreateData: (
    institutionAddFormFields: InstitutionAddEditFormFields,
) => InstitutionCreateData = (institutionAddFormFields) => {
    const {
        street,
        institutionAffiliation,
        institutionName,
        institutionType,
        zipCode,
        city,
        nurseryRegistryNumber,
        rspoNumber,
        regonNumber,
    } = institutionAddFormFields;

    return {
        regon: regonNumber,
        name: institutionName,
        street,
        zipCode,
        city,
        publicInstitution: institutionAffiliation === 'public',
        type: institutionType,
        nurseryRegistryNumber,
        rspo: rspoNumber,
    };
};
